import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorksRecomendedStaff(companyId, regulationId, stageId, planWorkId, roleId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF].getRegulationsStagesPlanWorksRecomendedStaff,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
                roleId,
			},
		},
	)
}

export default {
	getRegulationsStagesPlanWorksRecomendedStaff,
}
